export const TestHooks = {
	CancelButton: 'cancel-button',
	ContinueButton: 'continue-button',
	BackButton: 'back-button',
	LlcMortgageInboxOption: 'llc-mortgage-inbox-option',
	AssystLenderCentreOption: 'assyst-lender-centre-option',
	AssystArrangedType: 'assyst-arranged-type',
	AssystBridgeType: 'assyst-bridge-type',
	EmailMortgageOption: 'email-mortgage-option',
	EmailArrangedType: 'email-arranged-type',
	EmailBridgeType: 'email-bridge-type',
	EmailVtbType: 'email-vtb-type',
	FaxMortgageOption: 'fax-mortgage-option',
	FaxArrangedType: 'fax-arranged-type',
	FaxBridgeType: 'fax-bridge-type',
	FaxVtbType: 'fax-vtb-type',
} as const;
